export enum Directions {
  RTL = "rtl",
  LTR = "ltr",
}

export enum Languages {
  ENGLISH = "en",
  ARABIC = "ar",
}

export enum Pages {
  LOGIN = "",
  REGISTER = "register",
  VERIFY = "verify",
  FORGOT_PASSWORD = "forget-password",
  RESET_PASSWORD = "reset-password",

  // Settings
  SETTINGS = "settings",
  ACCOUNTS = "accounts",
  CONCEPTS = "concepts",
  ADMINS = "admins",
  ADMIN_GROUPS = "admin-groups",
  ADMIN_ROLES = "admin-roles",
  LANGUAGES = "languages",
  FEATURES = "features",
  MEDIA = "media-library",

  // Loyalty Settings
  TIERS = "tiers",
  POINTS = "points",

  // Guests
  GUESTS = "guests",
  GUESTS_PROFILE = "guests-profile",
  CUSTOMER_STATS = "customerStats",
  CARD_CODES = "cardCodes",

  // Reports and Dashboards
  DASHBOARD = "overview",
  REPORTS_DASHBOARD = "ReportsDashboard",
  TRANSACTIONS = "transactions",
  ORDERED_ITEMS = "orderedItems",
  TIMELINES = "timelines",
}

export enum Orders {
  ASC = "asc",
  DSC = "desc",
}

export enum FormActions {
  ADD = "Add",
  EDIT = "Edit",
}

export enum QuestionTypes {
  TRUE_FALSE = "True False",
  CHOOSE = "Choose",
  CHOOSE_IMAGE = "Choose with Image",
  TEXT_IMAGE = "Text with Image",
  OPTIONS_IMAGE = "Options as Image",
  COMPLETE_IMAGE = "Complete with Image",
}

export enum TimelineActions {
  CHANGE_FACEBOOK = "Facebook link",
  CHANGE_INSTAGRAM = "Instagram link",
  CHANGE_NAME = "name",
  CHANGE_GROUP = "Group",
  CHANGE_TIER = "Tier",
  CHANGE_EMAIL = "Email",
  CHANGE_VERIFICATION_STATUS = "Verify Guest",
  ADD_INTEREST = "Add Customer Interests",
  REMOVE_INTEREST = "Remove Customer Interests",
  ADD_FLAG = "Add Customer Flags",
  REMOVE_FLAG = "Remove Customer Flags",
  CHANGE_PHONE_NUMBER = "Phone Number",
  REDEEM_POINTS = "Redeem Points",
  REWARD_POINTS = "Reward Points",
  REFUND_POINTS = "Refund Points",
  WELCOME_POINTS = "Welcome Points",
}

// LoyaltyOperations.REWARD_POINTS
export enum LoyaltyOperations {
  REDEEM_POINTS = "Redeem Points",
  REWARD_POINTS = "Reward Points",
  REFUND_POINTS = "Refund Points",
  LOYALTTY_DISCOUNT = "Loyalty Discount",
}

export enum Channels {
  TELEPHONE_CHANNEL = "telephone",
  ANDROID_CHANNEL = "android",
  IPHONE_CHANNEL = "iphone",
  WEB_CHANNEL = "web",
}

export enum ResourceTypes {
  CUSTOMER = "customer",
  BOOKING = "booking",
}

export enum BookingTimelineActions {
  TIME_SLOT = "Update time slot",
  STATUS = "Update Booking Status",
  TABLE = "Update Booking Table",
  DATE = "Update Booking Date",
  GUEST_COUNT = "Update Guest Count",
  RESERVATION_EMAIL = "Send Reservation Email",
}

export enum AuthErrors {
  USER_EXISTS = "UsernameExistsException",
}

export enum AdminsGroups {
  ADMIN = "admin",
}

export enum AdminsConstants {
  ADMINS_API = "AdminQueries",
}

export enum AdminsApiPaths {
  LIST_USERS = "/listUsers",
  LIST_USERS_IN_GROUP = "/listUsersInGroup",
  LIST_GROUPS_FOR_USER = "/listGroupsForUser",
  GET_USER = "/getUser",
  LIST_GROUPS = "/listGroups",
  ADD_USER_TO_GROUP = "/addUserToGroup",
  REMOVE_USER_FROM_GROUP = "/removeUserFromGroup",
  DISABLE_USER = "/disableUser",
  ENABLE_USER = "/enableUser",
}

export enum StatuesIds {
  CANCELLED = "151a9e09-5d09-4f07-9928-90cccf46f41d",
  CLOSED = "1ca36387-69d5-4dba-be42-634b34493729",
}

export const NOTIFICATION_CHANNELS = [
  { label: "email", value: "email" },
  { label: "sms", value: "sms" },
];

export const ENCRYPTION_KEY =
  "123456dasflasdldfl789asjdflkj3fadsfsdlfds0123456";

export enum ADMIN_ROLES {
  SETTINGS = "settings_access",
  DASHBOARD = "dashboard_access",
  CUSTOMERS = "customers_access",
  ALL_CONCEPTS = "all_concepts",
}

export enum AccountDomain {
  TRADEFY_DOMAIN = "anyware",
  KEMPINSKI_DOMAIN = "kempinski",
  WESTIN_DOMAIN = "westin",
}

export enum LOCAL_STORAGE {
  SELECTED_CONCEPT = "selected-concept",
  GUESTS_SEARCH = "guests-search",
  VERSION = "version",
  VERSION_CHECKING = "version_checking",
  LAST_VISIT = "lastVisit",
}

export const GLOBAL_GUEST_ID = "12345";
